import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { config } from "../config/environment";

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { setExid } = useAppContext();

  useEffect(() => {
    // Récupérer le paramètre de requête "exid"
    const urlParams = new URLSearchParams(window.location.search);
    const exidParam = urlParams.get("exid");

    if (exidParam) {
      setExid(exidParam);
      console.log("Paramètre exid reçu:", exidParam);
      // Navigation vers la page de vérification d'identité
      navigate("/idcheck");
    } else {
      // Redirection si pas d'exid
      window.location.href = config.REDIRECT_URL;
    }
  }, [setExid, navigate]);

  return (
    <div className="loading-screen">
      <h2>Initialisation...</h2>
      <p>Vérification des paramètres</p>
    </div>
  );
};

export default HomePage;
